export default __webpack_public_path__ + "static/7-2e90cb7f96508c8eb2a69cda8f248f5f.jpg";